<template>
  <div>
    <PageTitle :route="$route" />

    <PageRowWrapper>
      <div class="col-sm-12">
        <ReportLastPositions />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import ReportLastPositions from '@/components/reports/lastpositions/LastPositions'

export default {
  name: 'ReportLastPositionsView',
  components: {
    PageTitle,
    PageRowWrapper,
    ReportLastPositions
  }
}
</script>
